import { render, staticRenderFns } from "./WasteCollectDrawer.vue?vue&type=template&id=4e32fc60&scoped=true&"
import script from "./WasteCollectDrawer.vue?vue&type=script&lang=js&"
export * from "./WasteCollectDrawer.vue?vue&type=script&lang=js&"
import style0 from "./WasteCollectDrawer.vue?vue&type=style&index=0&id=4e32fc60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e32fc60",
  null
  
)

export default component.exports